exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1o8sTPxQEd03A3cjqBkKzm{font-size:28px;color:#007bbb}html[dir=ltr] ._1o8sTPxQEd03A3cjqBkKzm{padding-left:6px}html[dir=rtl] ._1o8sTPxQEd03A3cjqBkKzm{padding-right:6px}._33-IimeRVMsjJoWdrMssX1{font-size:14px;font-weight:400}html[dir=ltr] ._33-IimeRVMsjJoWdrMssX1{padding-left:20px}html[dir=rtl] ._33-IimeRVMsjJoWdrMssX1{padding-right:20px}html[dir=ltr] ._2pXa7IlPJU1A3Y5vBGtHfc{padding-left:20px}html[dir=rtl] ._2pXa7IlPJU1A3Y5vBGtHfc{padding-right:20px}._3Nqv1O0J0fciQoC94o8e2Y{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;height:28px}._3Nqv1O0J0fciQoC94o8e2Y,.zGbo4QezyqQcfFg9ZYJ3g{display:-webkit-box;display:-ms-flexbox;display:flex}", ""]);

// exports
exports.locals = {
	"linkedInLogo": "_1o8sTPxQEd03A3cjqBkKzm",
	"linkedInLabel": "_33-IimeRVMsjJoWdrMssX1",
	"linkedInLink": "_2pXa7IlPJU1A3Y5vBGtHfc",
	"appElement": "_3Nqv1O0J0fciQoC94o8e2Y",
	"appDescription": "zGbo4QezyqQcfFg9ZYJ3g"
};